import { render, staticRenderFns } from "./DefaulCli.vue?vue&type=template&id=5e4dd607&scoped=true"
import script from "./DefaulCli.vue?vue&type=script&lang=js"
export * from "./DefaulCli.vue?vue&type=script&lang=js"
import style0 from "./DefaulCli.vue?vue&type=style&index=0&id=5e4dd607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dd607",
  null
  
)

export default component.exports